import { AlertTriangle, ShieldQuestion, MapPinOff } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const ProblemSection = () => {
  const { t } = useLanguage();

  const painPoints = [
    { icon: AlertTriangle, titleKey: "problem.1.title", descKey: "problem.1.desc" },
    { icon: ShieldQuestion, titleKey: "problem.2.title", descKey: "problem.2.desc" },
    { icon: MapPinOff, titleKey: "problem.3.title", descKey: "problem.3.desc" },
  ];

  return (
    <section className="py-24 bg-paper">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16 max-w-2xl mx-auto">
          <div className="eyebrow mb-4" style={{ color: "#6C4DFF" }}>{t("eyebrow.problem")}</div>
          <h2 className="font-display text-4xl md:text-5xl text-paper-ink mb-4">{t("problem.title")}</h2>
          <p className="text-lg text-paper-ink/60">{t("problem.sub")}</p>
        </div>
        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {painPoints.map((point, i) => (
            <article key={i} className="bg-paper-light border border-paper-ink/10 rounded-3xl p-7">
              <div className="w-11 h-11 rounded-xl bg-violet-solid/10 flex items-center justify-center mb-5">
                <point.icon className="h-5 w-5 text-violet-solid" />
              </div>
              <h3 className="font-display text-2xl text-paper-ink mb-2">{t(point.titleKey)}</h3>
              <p className="text-paper-ink/60 text-sm leading-relaxed">{t(point.descKey)}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
